/* eslint-disable import/prefer-default-export */

import { SET_RUNTIME_VARIABLE, RUNTIME_MODAL } from '../constants';

export function setRuntimeVariable({ name, value }) {
  return {
    type: SET_RUNTIME_VARIABLE,
    payload: {
      name,
      value,
    },
  };
}

export function alert({ title, body, buttonLabel }) {
  return setRuntimeVariable({
    name: RUNTIME_MODAL,
    value: {
      type: 'alert',
      payload: {
        title, body, buttonLabel,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/actions/runtime.js